<template>
  <!--编辑合伙人 对话框 -->
  <el-drawer
    title="添加合伙人"
    :visible.sync="show"
    :with-header="false"
    :before-close="closeDialog"
    size="60%"
  >
    <!-- 基本信息表单 -->
    <div class="form-box">
      <template>
        <el-form
          ref="form"
          :model="submit_data"
          label-width="80px"
          style="height: 90vh; overflow-y: auto"
        >
          <el-form-item label="合伙人姓名:" label-width="120px">
            <el-input
              v-model="submit_data.promoter_name"
              placeholder="请输入合伙人姓名"
              style="width: 300px"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="手机号:" label-width="120px">
            <el-input
              v-model="submit_data.promoter_phone"
              :placeholder="submit_rules.promoter_phone.placeholder"
              style="width: 300px"
            >
            </el-input>
          </el-form-item>
<!-- 
          <el-form-item label="城市" label-width="120px">
            <el-select
              v-model="value_city_code"
              placeholder="请选择城市"
              style="width: 300px"
              @visible-change="cityVisibleChange"
              @change="cityChange"
              @clear="clear"
              clearable
            >
              <el-option
                v-for="item in options_city_code"
                :key="item.value"
                :label="item.city.name"
                :value="item.city.city_code"
              >
              </el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="备注:" label-width="120px">
            <el-input
              v-model="submit_data.remarks"
              placeholder="请输入备注"
              style="width: 80%"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </template>
    </div>

    <!-- 对话框底部按钮 -->
    <div style="display: flex; justify-content: center; margin-top: 20px">
      <submitBtn
        :data="submit_data"
        :rules="submit_rules"
        :url="submit_url"
        @onSubmitDig="onSubmitDig"
        :JSON_Boolean="false"
      />

      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </el-drawer>
</template>

<script>
var _this;

export default {
  props: {
    isShow: Boolean,
    data: "",
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;

      if (_this.data.editFlag == "edit") {
        // 如果是编辑按钮点击进来的

        _this.search_data.promoter_code = _this.data.promoter_code;
        // _this.value_city_code = _this.data.city_name;
        _this.getDistributionPromoter();

        _this.submit_url = "/distribution/editDistributionPromoter";

        _this.submit_data.promoter_code = _this.data.promoter_code;

        // _this.cityChange(_this.data.city_code); 加上就报错？？

        _this.getDistributionPromoter();
      } else if (_this.data.editFlag == "add") {
  
        _this.submit_url = "/distribution/addDistributionPromoter";
      }
      // _this.submit_data.city_code = JSON.parse(localStorage.getItem('login')).city.city_code; 



    },
  },
  data() {
    return {
      show: false,
      submit_url: "/distribution/addDistributionPromoter",

      // 下拉搜索城市
      value_city_code: "",
      options_city_code: [],
      company_promoter_name: "",

      // 表单数据
      submit_data: {
        // city_code: "",
        promoter_name: "",
        promoter_phone: "",
        remarks: "",
      },
      search_data: {
   
        promoter_code: "",
      },

      submit_rules: {
        promoter_name: {
          placeholder: "合伙人姓名",
          rules: {
            required: true,
            message: "合伙人姓名需在50字之内",
            regulation: "elt_str",
            rulesData: 50,
          },
        },

        promoter_phone: {
          placeholder: "合伙人电话",
          rules: {
            required: true,
            message: "请输入合伙人电话",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        // city_code: {
        //   placeholder: "城市",
        //   rules: {
        //     required: true,
        //     message: "城市选择错误",
        //     regulation: "gt_str",
        //     rulesData: 0,
        //   },
        // },

        remarks: {
          placeholder: "备注，200字节之内",
          rules: {
            required: false,
            message: "备注，200字节之内",
            regulation: "elt_str",
            rulesData: 200,
          },
        },
      },
    };
  },
  created() {
    _this = this;
  },
  methods: {
    //清除select 内容
    clear(val) {

      _this.company_promoter_name = "";
    },


    // 选择城市
    cityChange(val) {

      let cityList = _this.options_city_code.find(
        (item) => item.city.city_code == val
      );


    },
    //搜索的下拉框弹出触发
    cityVisibleChange() {
      // 请求公司管理接口获取公司唯一编码

      _this
        .$post("/city/cityLists", {
          page: 1,
          limit: 50,
          promoter_name: "",

        })
        .then((res) => {
          _this.options_city_code = res.data;
        })
        .catch((err) => {});
    },

    // 关闭方法
    closeDialog() {
      _this.show = false;
      _this.submit_url = "/distribution/addDistributionPromoter";
      // 下拉搜索城市
      _this.value_city_code = "";
      _this.options_city_code = [];
      _this.company_promoter_name = "";
      _this.search_data = {

        promoter_code: "",
      };
      _this.submit_data = {

        promoter_name: "",
        promoter_phone: "",
        remarks: "",
      };
    },

    // 提交
    onSubmitDig() {
      // 触发父组件自定义事件刷新表格
      _this.$emit("onSubmit");
      _this.closeDialog();
    },
    // 获取详情方法
    getDistributionPromoter() {
      _this
        .$post("/distribution/getDistributionPromoter", _this.search_data)
        .then((res) => {
          _this.submit_data.promoter_name = res.data.promoter_name;
          _this.submit_data.promoter_phone = res.data.promoter_phone;
          _this.submit_data.remarks = res.data.remarks;
        })
        .catch((res) => {});
    },
  },
};
</script>

<style scoped>
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
  height: 85vh;
  overflow-y: auto;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-form-second {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
}

.el-form-second {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
}

.map {
  height: 60%;
  width: 100%;
  margin-bottom: 20px;
}
</style>